<template>
  <form @submit.prevent="verify" @keydown="form.onKeydown($event)">
    <!-- Email -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">メールアドレス</label>
      <div class="col-md-7">
        <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" class="form-control" type="email" name="email" @blur="onBlurEmail">
        <has-error :form="form" field="email"/>
      </div>
    </div>

    <!-- Password -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">パスワード</label>
      <div class="col-md-7">
        <input v-model="form.password" :class="{ 'is-invalid': form.errors.has('password') }" class="form-control" type="password" name="password" @blur="onBlurPassword">
        <has-error :form="form" field="password"/>
      </div>
    </div>

    <!-- Remember Me -->
    <div class="form-group row">
      <div class="col-md-3"/>
      <div class="col-md-7 d-flex">
        <checkbox v-model="remember" name="remember">
          次回から自動ログイン
        </checkbox>

        <router-link :to="{ name: 'password.request' }" class="small ml-auto my-auto">
          パスワードを忘れですか？
        </router-link>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-7 offset-md-3">
        <!-- Submit Button -->
        <v-button :loading="form.busy">
          ログイン
        </v-button>
        
        <hr>

        <div class="text-right">

          <!-- Facebook Login Button -->
          <login-with-facebook @success="$emit('success')">
            Facebookでログイン
          </login-with-facebook>

          <!-- Google Login Button -->
          <login-with-google @success="$emit('success')">
            Googleでログイン
          </login-with-google>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Form from 'vform'
import LoginWithFacebook from '~/components/LoginWithFacebook'
import LoginWithGoogle from '~/components/LoginWithGoogle'

export default {
  middleware: 'guest',

  components: {
    LoginWithFacebook,
    LoginWithGoogle
  },

  metaInfo () {
    return { title: 'ログイン' }
  },

  data: () => ({
    form: new Form({
      email: '',
      password: ''
    }),
    remember: false
  }),

  methods: {
    async verify () {
      await this.$recaptcha('login').then((token) => {
        this.login()
      })
    },

    async login () {
      // Submit the form.
      const { data } = await this.form.post('/api/login')

      // Save the token.
      this.$store.dispatch('auth/saveToken', {
        token: data.token,
        remember: this.remember
      })

      // Fetch the user.
      await this.$store.dispatch('auth/fetchUser')

      this.$emit('success')
    },

    onBlurEmail(e) {
      if (e && this.form.email !== e.target.value) this.form.email = e.target.value
    },

    onBlurPassword(e) {
      if (e && this.form.password !== e.target.value) this.form.password = e.target.value
    },
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Login.vue